/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { Injectable, inject } from '@angular/core';
import { Auth, user } from '@angular/fire/auth';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { LocalStorageHelper } from 'src/app/plain-javascript/services/LocalStorageHelper';
import { AuthService } from 'src/app/services/auth.service';

/**
 * This service exists to handle the case when a user closes the browser after starting a migration.
 * That scenario results in a "sketchy" 2 firebase apps with unknown access state. So this will force
 * the same logout that would normally happen after migration.
 */
@Injectable({ providedIn: 'root' })
export class InProgressMigrationCheck {
	private authService = inject(AuthService);
	private auth = inject(Auth);
	//hack for the unit test <_< (stupid es6 modules)
	private user = user;

	private localStorageKey = 'userTenantMigrationInProgress';
	public saveMigrationInProgress() {
		LocalStorageHelper.write(this.localStorageKey, true);
	}

	public clearMigrationInProgress() {
		LocalStorageHelper.remove(this.localStorageKey);
	}

	public cleanupAfterMigration() {
		if (!LocalStorageHelper.read(this.localStorageKey)) {
			return;
		}

		this.user(this.auth)
			.pipe(
				filter((user) => !!user?.email),
				switchMap((user) => this.authService.queryTenantViaEmail(user.email)),
				map((emailTenant) => emailTenant?.claimCompleted),
				take(1)
			)
			.subscribe((needToCleanUp) => {
				if (needToCleanUp) {
					LocalStorageHelper.remove(this.localStorageKey);
					this.authService.logout();
				}
			});
	}
}
